import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter2 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 13,
	viewBox: "0 0 16 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.0977 0.625H1.875C1.13672 0.625 0.726562 1.5 1.19141 2.07422L6.25 8.14453V10.6875C6.25 10.9062 6.33203 11.125 6.52344 11.2344L8.71094 12.7656C8.82031 12.8477 8.95703 12.875 9.06641 12.875C9.42188 12.875 9.75 12.6289 9.75 12.2188V8.14453L14.7812 2.07422C15.2461 1.5 14.8359 0.625 14.0977 0.625ZM9.06641 7.59766L8.875 7.84375V11.8086L7.125 10.5781V7.84375L6.90625 7.59766L1.875 1.5H14.0977L9.06641 7.59766Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgFilter2);
export { ForwardRef as ReactComponent };
